import { render, staticRenderFns } from "./AdTip.vue?vue&type=template&id=80568d24&scoped=true&"
import script from "./AdTip.vue?vue&type=script&lang=js&"
export * from "./AdTip.vue?vue&type=script&lang=js&"
import style0 from "./AdTip.vue?vue&type=style&index=0&id=80568d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80568d24",
  null
  
)

export default component.exports